import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VToolbar,{attrs:{"flat":"","height":"40","color":_vm.color}},[_c(VToolbarTitle,{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c(VSpacer),_vm._t("right")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }